import React from 'react'
import styled from '@emotion/styled'

import {Icon} from '@vio/atlas/Icon'
import {NAV_BAR_MOBILE_HEIGHT, NavBar} from '@vio/atlas/NavBar'
import {Button} from '@vio/atlas/src/components/designSystem/Button'
import {Text} from '@vio/atlas/Text'
import mirror from '@vio/atlas/utils/mirror'

import {MirroredIcon} from '../../booking/MirroredIcon'
import {AccommodationFloatingHeader} from '../AccommodationFloatingHeader'

interface Props {
  title: React.ReactNode
  isRoomNameInView: boolean
  onBackButtonClick?: () => void
  isStatic?: boolean
}

const MobileHeaderWrapper = styled.div<{visible: boolean}>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 2;
  transition:
    transform 300ms cubic-bezier(0.2, 0, 0, 1),
    opacity 300ms ease-in-out;
  transform: translateY(${({visible}) => (visible ? '0' : '-100%')});
  opacity: ${({visible}) => (visible ? 1 : 0)};
  will-change: transform, opacity;
`

const RoomName = styled(Text)`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  overflow: hidden;
  -webkit-line-clamp: 1;
`

const HeaderSpacer = styled.div`
  height: ${`${NAV_BAR_MOBILE_HEIGHT}px`};
`

const BackButton = styled(Button)`
  ${mirror()}
`

export const RoomDetailsMobileHeader = ({
  title,
  isRoomNameInView,
  onBackButtonClick = () => {},
  isStatic = false
}: Props) => {
  return (
    <>
      <MobileHeaderWrapper visible={isStatic || !isRoomNameInView}>
        <NavBar
          centerAligned
          withDivider
          startContent={
            <BackButton
              hasTouchArea
              size="md"
              variant="ghost"
              dataId="BackButton"
              iconStart={<Icon name="ChevronLeft" />}
              onClick={onBackButtonClick}
            />
          }
          centerContent={
            <RoomName variant="titleM" dir="auto">
              {title}
            </RoomName>
          }
        />
      </MobileHeaderWrapper>
      {isStatic ? (
        <HeaderSpacer />
      ) : (
        <AccommodationFloatingHeader
          leftSlot={
            <Button
              variant="tertiary"
              isRounded
              isFloating
              iconStart={<MirroredIcon name="ChevronLeft" size="md" />}
              dataId="BackButton"
              onClick={onBackButtonClick}
              size="lg"
            />
          }
        />
      )}
    </>
  )
}
